import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import LandingBanner from './components/LandingBanner';
import DomainCardsSection from './components/DomainCardsSection';
import UpArrow from './components/UpArrow';
import { analytics } from './components/firebase/firebase';
import { logEvent as firebaseLogEvent } from 'firebase/analytics';

const LandingPage = () => {
  const [showDomainCards, setShowDomainCards] = useState(false);

  // Log page view when LandingPage mounts - with minimal data
  useEffect(() => {
    firebaseLogEvent(analytics, 'page_view', { action: 'view' });
  }, []);

  return (
    <div className="min-h-screen bg-black">
      <AnimatePresence mode="wait">
        {showDomainCards ? (
          <motion.div
            key="domain-cards"
            initial={{ x: "100%", opacity: 0 }}
            animate={{ x: "0%", opacity: 1 }}
            exit={{ x: "-100%", opacity: 0 }}
            transition={{ 
              duration: 0.6,
              ease: [0.6, 0.01, -0.05, 0.95],
              opacity: { duration: 0.8 }
            }}
            className="min-h-screen bg-gray-900"
          >
            <DomainCardsSection />
            <AnimatePresence>
              {showDomainCards && (
                <UpArrow onClick={() => setShowDomainCards(false)} />
              )}
            </AnimatePresence>
          </motion.div>
        ) : (
          <motion.div
            key="landing-banner"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4 }}
          >
            <LandingBanner onEnter={() => setShowDomainCards(true)} />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default LandingPage;